export default {
    namespaced: true,

    state: {
        item: null,
        show: false
    },

    getters: {
        item: state => state.item,
        show: state => state.show
    },

    mutations: {
        show(state, data) {
            state.show = data.show !== undefined ? data.show : true
            state.item = data.item
        }
    }
}
